export default "__VITE_PUBLIC_ASSET__b66820eb__"